export default "__VITE_ASSET__d5644749__"